import React from 'react'
import ErrorReport from 'Components/ErrorReport'
import VesselDetailsHeader from 'Components/VesselDetailsHeader'
import env from 'environment_system/env_system'
import { Card, CardHeader, Row, Col, CardBody, TabContent, TabPane, CardFooter } from 'reactstrap'
import { DeckReportTabsConstant, AddInfoConstant } from 'shared/constants'
import EconAddInformation from './AdditionalInformation/Econ/EconAddInformation'
import LfondsAddInformation from './AdditionalInformation/Lfonds/LfondsAddInformation'
import ProactiveAddInformation from './AdditionalInformation/Proactive/ProactiveAddInformation'
import CIIAdjustmentComponent from './ReportComponents/CIIAdjustmentComponent'
import CpWarrantyComponent from './ReportComponents/CpWarrantyComponent'
import DeckRemarks from './ReportComponents/DeckRemarks'
import DraftsCargoLadingComponent from './ReportComponents/DraftsCargoLading/DraftsCargoLadingComponent'
import ETADComponent from './ReportComponents/ETADComponent'
import STSOperationComponent from './ReportComponents/STSOperationComponent'
import WeatherData from './ReportComponents/WeatherData'
import { RootState } from 'index'
import { useSelector } from 'react-redux'
import { useLocation } from "react-router-dom";
import FormLoading from 'Components/FormLoading'
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider'

const DeckOfficerReportingStructure = ({
    handleVesselState,
    CIIAdjustmentEventsLoading,
    toggleTab,
    errorMessage,
    setErrorMessage,
    filteredCIIEventsList,
    toggleAddLfondsTab,
}: any) => {
    const { activeDeckTab, activeAddLfondsTab, editReportBool, previousDeckTabIndex } = useEditReport();
    const { VesselID, VoyageID, ReportID, loading, CurrentReport } = useSelector((state: RootState) => state.Reporting);
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    const location = useLocation();
    return (
        <Card>
            {!editReportBool &&
                <CardHeader className="p-2">
                    <Row>
                        <Col sm="2" className="d-flex align-items-center">
                            <button color='primary' className='btn btn-primary' onClick={() => { handleVesselState('ONGOING_VESSEL_REPORTING') }}>
                                <i className="bx bx-chevron-left me-1" /> Back
                            </button>
                        </Col>
                        <Col sm="10">
                            <VesselDetailsHeader />
                        </Col>
                    </Row>
                </CardHeader>
            }
            <CardBody className="p-0">
                {loading && <FormLoading />}
                {!(loading || CIIAdjustmentEventsLoading) &&
                    <div id="basic-pills-wizard" className="twitter-bs-wizard">
                        <TabContent
                            activeTab={activeDeckTab}
                        >
                            {activeDeckTab === DeckReportTabsConstant.WeatherDataId &&
                                <TabPane tabId={DeckReportTabsConstant.WeatherDataId} className="tabHeight">
                                    <WeatherData
                                        toggleTab={toggleTab}
                                        setErrorMessage={setErrorMessage}
                                    />
                                </TabPane>
                            }
                            {activeDeckTab === DeckReportTabsConstant.CIIAdjustmentId &&
                                <TabPane tabId={DeckReportTabsConstant.CIIAdjustmentId} className="">
                                    <CIIAdjustmentComponent
                                        toggleTab={toggleTab}
                                        setErrorMessage={setErrorMessage}
                                        filteredCIIEventsList={filteredCIIEventsList}
                                    />
                                </TabPane>
                            }
                            {activeDeckTab === DeckReportTabsConstant.STSId &&
                                <TabPane tabId={DeckReportTabsConstant.STSId} className="tabHeight">
                                    <STSOperationComponent
                                        toggleTab={toggleTab}
                                        setErrorMessage={setErrorMessage}
                                    />
                                </TabPane>
                            }
                            {activeDeckTab === DeckReportTabsConstant.CPWarrantiesId &&
                                <TabPane tabId={DeckReportTabsConstant.CPWarrantiesId}>
                                    <CpWarrantyComponent
                                        toggleTab={toggleTab}
                                        setErrorMessage={setErrorMessage}
                                    />
                                </TabPane>
                            }
                            {activeDeckTab === DeckReportTabsConstant.DraftsCargoReeferBillBallastId &&
                                <TabPane tabId={DeckReportTabsConstant.DraftsCargoReeferBillBallastId}>
                                    <DraftsCargoLadingComponent
                                        toggleTab={toggleTab}
                                        setErrorMessage={setErrorMessage}
                                    />
                                </TabPane>
                            }
                            {activeDeckTab === DeckReportTabsConstant.ETADId &&
                                <TabPane tabId={DeckReportTabsConstant.ETADId}>
                                    <ETADComponent
                                        activeTab={previousDeckTabIndex}
                                        toggleTab={toggleTab}
                                        key="ETADComponent"
                                        setErrorMessage={setErrorMessage}
                                    />
                                </TabPane>
                            }
                            {activeDeckTab === DeckReportTabsConstant.AdditionalDetailsId && env?.additional_info_deck === AddInfoConstant.ECON_DECK &&
                                <TabPane tabId={DeckReportTabsConstant.AdditionalDetailsId}>
                                    <EconAddInformation
                                        toggleTab={toggleTab}
                                        activeTab={previousDeckTabIndex}
                                        setErrorMessage={setErrorMessage}
                                        editReportBool={editReportBool}
                                    />
                                </TabPane>
                            }
                            {activeDeckTab === DeckReportTabsConstant.AdditionalDetailsId && env?.additional_info_deck === AddInfoConstant.LFONDS_DECK &&
                                <TabPane tabId={DeckReportTabsConstant.AdditionalDetailsId}>
                                    <LfondsAddInformation
                                        activeTab={previousDeckTabIndex}
                                        toggleTab={toggleTab}
                                        setErrorMessage={setErrorMessage}
                                        activeAddLfondsTab={activeAddLfondsTab}
                                        toggleAddLfondsTab={toggleAddLfondsTab}
                                        editReportBool={editReportBool}
                                    />
                                </TabPane>
                            }
                            {activeDeckTab === DeckReportTabsConstant.AdditionalDetailsId && env?.additional_info_deck === AddInfoConstant.PROACTIVE_DECK &&
                                <TabPane tabId={DeckReportTabsConstant.AdditionalDetailsId}>
                                    <ProactiveAddInformation
                                        ReportID={ReportID}
                                        VesselID={VesselID}
                                        VoyageID={VoyageID}
                                        activeTab={previousDeckTabIndex}
                                        toggleTab={toggleTab}
                                        record={currentVesselReport}
                                    />
                                </TabPane>
                            }
                            {activeDeckTab === DeckReportTabsConstant.RemarksId &&
                                <TabPane tabId={DeckReportTabsConstant.RemarksId}>
                                    <DeckRemarks
                                        toggleTab={toggleTab}
                                        handleVesselState={handleVesselState}
                                        setErrorMessage={setErrorMessage}
                                        toggleAddLfondsTab={toggleAddLfondsTab}
                                    />
                                </TabPane>
                            }
                        </TabContent>
                    </div>
                }
            </CardBody>
            {/* If we get error from server then call ErrorReport component to show error with fields in footer */}
            {
                errorMessage && env?.form_validation &&
                <CardFooter>
                    <ErrorReport
                        errorMessages={errorMessage}
                        ui_url={location.pathname}
                        setErrorMessage={setErrorMessage} />
                </CardFooter>
            }
        </Card>
    )
}

export default DeckOfficerReportingStructure